var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconShare = function SvgIconShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D5E2F2",
    d: "M16.95 10.35a3.3 3.3 0 1 0-3.227-2.609L9.539 9.833a3.3 3.3 0 1 0 0 4.334l4.184 2.092a3.3 3.3 0 1 0 .739-1.476l-4.184-2.092a3.3 3.3 0 0 0 0-1.382l4.183-2.092a3.3 3.3 0 0 0 2.489 1.133"
  })));
};
export default SvgIconShare;